// extracted by mini-css-extract-plugin
export default {"root":"GnIzqh","wrapper":"UFqbgQ","open":"FFMhFS","appear":"FROSIT","fullScreen":"JCNYtS","popover":"fBvWxv"};